
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.547 4.813l-.667.267a2.003 2.003 0 00-.447-.26l-.1-.707A.136.136 0 009.2 4H8.133a.124.124 0 00-.126.113l-.1.707c-.16.067-.314.153-.447.26l-.667-.267c-.06-.02-.133 0-.16.06l-.533.92a.134.134 0 00.033.174l.567.44a1.11 1.11 0 00-.033.26c0 .086.006.173.02.26l-.56.44a.126.126 0 00-.034.166l.534.927c.033.06.1.08.166.06l.66-.267c.14.107.287.194.454.26L8 9.22a.136.136 0 00.133.113H9.2c.067 0 .12-.046.133-.113l.1-.707c.16-.066.314-.153.447-.26l.66.267c.06.027.133 0 .16-.06l.533-.927a.125.125 0 00-.033-.166l-.553-.44a1.7 1.7 0 000-.52l.566-.44a.133.133 0 00.034-.174l-.534-.92c-.033-.06-.106-.08-.166-.06zM8.667 7.62a.953.953 0 110-1.906.953.953 0 010 1.906z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M13.293 6.04c-.286-2.18-2.153-3.907-4.353-4.033C8.847 2 8.76 2 8.667 2a4.663 4.663 0 00-4.614 4L2.767 8.32a.665.665 0 00.566 1.013H4v1.334C4 11.4 4.6 12 5.333 12H6v2h4.667v-3.12a4.677 4.677 0 002.626-4.84zM9.927 9.753l-.594.28v2.634h-2v-2h-2V8h-.866l.886-1.553a3.325 3.325 0 013.314-3.114A3.335 3.335 0 0112 6.667c0 1.393-.86 2.586-2.073 3.086z","fill":"currentColor"}})])
          )
        }
      }
    